import { BalanceResolver } from "../../lib/balances/balanceResolver";
import { GasResolver } from "../../lib/gases/gasResolver";
import { NftBalanceResolver } from "../nft/nftBalanceResolver";
import { TransferResolver } from "../transfers/transferResolver";
import { GaslessResolver } from "../gasless/gaslessResolver";
import { ContractAddressResolver } from "../../lib/address/contractAddressResolver";
import { RpcHealthCheckResolver } from "../rpcHealth/rpcHealthCheckResolver";
class UtilsResolverService {
    constructor() {
        this.balanceResolver = null;
        this.gasResolver = null;
        this.nftResolver = null;
        this.transferResolver = null;
        this.contractAddressResolver = null;
        this.rpcHealthCheckResolver = null;
        this.gaslessResolver = null;
    }
    setProviders(balanceProviders, gasProviders, nftProviders, transferProviders, contractAddressProviders, rpcHealthCheckProviders, gaslessProviders = []) {
        this.balanceResolver = new BalanceResolver(balanceProviders);
        this.gasResolver = new GasResolver(gasProviders);
        this.nftResolver = new NftBalanceResolver(nftProviders);
        this.transferResolver = new TransferResolver(transferProviders);
        this.contractAddressResolver = new ContractAddressResolver(contractAddressProviders);
        this.rpcHealthCheckResolver = new RpcHealthCheckResolver(rpcHealthCheckProviders);
        this.gaslessResolver = new GaslessResolver(gaslessProviders);
    }
    getBalanceResolver() {
        if (!this.balanceResolver) {
            throw new Error('ResolverService not initialized. Make sure to call setProviders first.');
        }
        return this.balanceResolver;
    }
    getGasResolver() {
        if (!this.gasResolver) {
            throw new Error('ResolverService not initialized. Make sure to call setProviders first.');
        }
        return this.gasResolver;
    }
    getNftResolver() {
        if (!this.nftResolver) {
            throw new Error('NftResolverService not initialized. Make sure to call setProviders first.');
        }
        return this.nftResolver;
    }
    getTransferResolver() {
        if (!this.transferResolver) {
            throw new Error('TransferResolver not initialized. Make sure to call setProviders first.');
        }
        return this.transferResolver;
    }
    getGaslessResolver() {
        if (!this.gaslessResolver) {
            throw new Error('GaslessResolver not initialized. Make sure to call setProviders first.');
        }
        return this.gaslessResolver;
    }
    getContractAddressResolver() {
        if (!this.contractAddressResolver) {
            throw new Error('ContractAddressResolver not initialized. Make sure to call setProviders first.');
        }
        return this.contractAddressResolver;
    }
    getRpcHealthCheckResolver() {
        return this.rpcHealthCheckResolver;
    }
}
export const resolverService = new UtilsResolverService();
